<p-toast></p-toast>
<div *ngIf="isChangeRequestDataLoaded" id="changeRequestHistoryModal">
  <p-dialog
    header="Change Request History"
    [(visible)]="isChangeRequestHistoryModalShow"
    [draggable]="false"
    [style]="{ width: '100vw', height: '95vh' }"
    (onHide)="closeChangeRequestItemHistoryModal()"
    [modal]="true"
    id="changeRequestHistoryDataModal"
  >
    <div *ngIf="displayStaticMessageForCRIDuringReview"> 
      <p-message severity="warn" text="{{changeRequestItemReviewStaticMessage}}" styleClass="p-mr-2"> </p-message>
    </div>
    <div *ngIf="displayStaticMessageForCRIDuringApproval"> 
      <p-message severity="error" text="{{changeRequestItemApprovalStaticMessage}}" styleClass="p-mr-2"></p-message>
    </div>
    <app-panel-list
      [panelList]="changeRequestPanelListInput" [noResultFound] = "noData"
      (selectedItems)="getSelectedItems($event)"
    >
      <ng-template #templateRef let-data="dataVar">
        <div panel-content class="change-request-history-panel">
          <div class="col max-w-8rem">
            <app-label labelText="Item #"></app-label>
            <app-read-only readonlyText="{{ data?.changeRequestItemNumber }}"></app-read-only>
            <app-label labelText="Type"></app-label>
            <app-read-only readonlyText="{{ data?.changeRequestItemType }}"></app-read-only>
          </div>
          <div class="col-2">
              <app-label labelText="Status"></app-label>
              <div class="grid">
                <div class="col max-w-0 pb-0">
                  <em
                    class="pi pi-circle-fill"
                    [ngClass]="calculateStatusColor(data?.status)"
                  ></em>
                </div>
                <div class="col ml-1 pb-0 max-w-11rem">
                  <app-read-only readonlyText="{{data?.statusName}}"></app-read-only>
                </div>
                <div class="col max-w-0">
                  <i
                    *ngIf="
                      data?.status == 'Rejected' && data?.rejectionComments != null
                    "
                    class="fas fa-comments p-button-rounded p-button-text btnBlueColored comment-icon"
                    pTooltip="{{ data?.rejectionComments }}"
                    appPreventDoubleClick
                    (debounceClick)="openMessageModal(data?.rejectionComments)"
                  ></i>
                </div>
              </div>
              <app-label labelText="{{ data?.reviewedOnDate | date: 'dd-MMM-yyyy' }}"></app-label>
            <div *ngIf="data.reasonForRejection != null">
              <app-read-only readonlyText="{{ data?.reasonForRejection }}"></app-read-only>
            </div>
          </div>
          <div class="col-3">
           <app-label labelText="Description"></app-label>
           <app-read-only readonlyText="{{ data?.description }}"></app-read-only>
          </div>
          <div class="col-3">
            <div *ngIf="data?.changeRequestItemType!=periodicReviewChangeRequestItemType">
                <app-label labelText="Benefits"></app-label>
              <app-read-only readonlyText="{{ data?.benefitOfChange }}"></app-read-only>
            </div>
          </div>
          <div class="col-2">
            <app-label labelText="Requested By"></app-label>
            <app-read-only readonlyText="{{ data?.requestedBy }}"
            [ngClass]="{'inActiveGroup':data?.requestedByIsTerminated ===true}"></app-read-only>
            <app-label labelText="Reviewed By"></app-label>
            <app-read-only readonlyText="{{ data?.reviewedBy }}"
            [ngClass]="{'inActiveGroup':data?.reviewedByIsTerminated===true}"></app-read-only>
          </div>
          <div class="col">
            <app-label labelText="Requested Date"></app-label>
            <app-read-only readonlyText="{{ data?.requestedDate | date: 'dd-MMM-yyyy' }}"></app-read-only>
          </div>
        </div>
      </ng-template>
    </app-panel-list>
    <ng-template
      *ngIf="getVisibilityOfChangeRequestItemFooter() && getCheckOutUserStatus()"
      pTemplate="footer"
    >
      <p-button
      appPreventDoubleClick
      *ngIf="isApprovalBtnVisible"
        label="Approve"
        icon="fa fa-check"
        id="approveButton"
        class="approve-button"
        iconPos="left"
        [disabled]="approvebtnDisabled"
        (debounceClick)="openPeriodicApprovalModal()"
        pTooltip="{{ approveButtonTooltipMessage }}"
      >
      </p-button>
      <p-button
        appPreventDoubleClick
        *ngIf="isDelayedApprovalBtnVisible"
        styleClass="p-button-outlined"
        label="Delayed Approval"
        icon="fa fa-clock"
        [disabled]="btnDisabled || !displayDelayedApprovalButtonForAutomatedCRI"
        (debounceClick)="updateStatus('Delayed Approval','')"
        id="delayedApprovalButton"
        class="delayed-approval-button"
        iconPos="left"
        pTooltip="{{ readyForApprovalButtonTooltipMessage }}"
      >
      </p-button>
      <p-button
        appPreventDoubleClick
        *ngIf="isDeferBtnVisible"
        styleClass="p-button-outlined"
        label="Defer"
        icon="fa fa-share"
        id="deferButton"
        class="defer-button"
        iconPos="left"
        [disabled]="btnDisabled || !displayDefferedButtonForAutomatedCRI"
        (debounceClick)="updateStatus('Deferred','')"
        pTooltip="{{ deferButtonTooltipMessage }}"
      >
      </p-button>
      <p-button
      appPreventDoubleClick
      *ngIf="isRejectBtnVisible"
        styleClass="p-button-outlined"
        label="Reject"
        icon="fa fa-times"
        id="rejectButton"
        class="reject-button"
        iconPos="left"
        [disabled]="btnDisabled||displayRejectButtonForAutomatedCRI"
        (debounceClick)="openPeriodicRejectionModal()"
        pTooltip="{{ rejectButtonTooltipMessage }}"  
        tooltipPosition="top"
      >
      </p-button>

      <p-button
      appPreventDoubleClick
      *ngIf=displayProceedBtn
      label="Proceed"
      icon="fa fa-check"
      id="proceedButton"
      class="proceed-button"
      iconPos="left"
      (debounceClick)="proceedToReviewDocument()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
    *ngIf=displayDeferAndProceedBtn
    label="Proceed & Defer"
    icon="fa fa-check"
    id="proceedAndDeferButton"
    class="proceedAndDefer-button"
    iconPos="left"
    (debounceClick)="deferAndproceedToAppoveDocument()"
    pTooltip="{{ proceedAndDeferButtonTooltipMessage }}"
  >
  </p-button>
    
    </ng-template>
    <div *ngIf="isRejectChangeRequestModal">
      <app-reject-change-request-modal
        [isRejectChangeRequestModal]="isRejectChangeRequestModal"
        [selectedItems]="crSelectedItems"
        [documentDetails]="documentDetailsDto"
        [isLatestVersion]="isLatestVersion"
        (isRejectChangeRequestModalVisible)="
          closeRejectChangeRequestModal($event)
        "
      ></app-reject-change-request-modal>
    </div>
    <div *ngIf="isPeriodicChangeRequestSelected">
      <app-approve-periodic-change-request-item-modal
        [isPeriodicApprovalModal]="isPeriodicApprovalModal"
        [selectedItems]="crSelectedItems"
        (isPeriodicApprovalModalVisible)="closeApproveChangeRequestModal($event)"
        (descriptionForPeriodicReviewApproval)="approvePeriodicReviewCRI($event)"
      ></app-approve-periodic-change-request-item-modal>
      <app-reject-periodic-change-request-item-modal
        [isRejectPeriodicChangeRequestModal]="isRejectPeriodicChangeRequestModal"
        [selectedItems]="crSelectedItems"
        [periodicReviewDate]="criPeriodcReviewDate"
        (isRejectPeriodicChangeRequestModalVisible)="closeRejectPeriodChangeRequestModal($event)"
        [documentDetails]="documentDetailsDto"
          [isLatestVersion]="isLatestVersion"
      ></app-reject-periodic-change-request-item-modal>
    </div>

  </p-dialog>
  <div *ngIf="isMsgModalVisible">
    <app-message
      [headerTxt]="headerMsgTxt"
      [messageTxt]="msgTxt"
      [isMessageModal]="isMsgModalVisible"
      (isMessageModalVisible)="closeMsgModal()"
    ></app-message>
  </div>
</div>
